<template>
    <div class="pcc-wrapper">
        <modal-x :show="showEditor" @onclose="showEditor=false" :contentStyle="{'max-width': '600px', height: '100%'}">
            <contact-editor :apiClient="apiClient" :userId="userId" v-if="showEditor" @oncreate="onContactCreated" :pickupEntry="pickupEntry" :skipAddress="skipAddress===true"></contact-editor>
        </modal-x>

        <div class="pcc-toolbar">
            <div v-if="!(hideAddNew)">
                <span @click="showEditor=true" class="pcc-btn-add">+ {{lang.contact.newContact}} </span>
                <span class="pcc-btn-refresh" @click="reload">{{lang.common.refresh}}</span>
            </div>
        </div>

        <div class="pcc-items-container">
            <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
                <div>
                    <div class="pcc-item-card" v-for="item in items" :key="item.id">
                        <div @click="onSelect(item)">
                            <div>
                                <div class="pcc-item-title">
                                    {{item.title}}({{item.id}})
                                </div>
                            </div>
                            <div class="pcc-item-detail">
                                <span class="pcc-label">{{lang.common.name}}:</span>{{item.name}} / <span class="pcc-label">{{lang.common.phone}}:</span>{{item.phone}}
                                <div>
                                    <div class="pcc-label">{{lang.contact.deliveryAddress}}:</div>
                                    <div>{{item.address}}</div>
                                </div>
                                <div v-if="item.pickContact!==null" class="pcc-pickup-section">
                                    <div class="pcc-pickup-badge"> {{lang.common.pickup}} </div>
                                    <div>{{item.pickContact.title}}:{{item.pickContact.phone}}</div>
                                    <div>{{item.pickContact.address}}</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </paged-loading>
        </div>
    </div>
</template>
<script>
    import pagedLoading from './base/PagedLoading.vue';
    import queryString from '../utl/queryString';
    import modalX from './base/ModalX1.vue';
    import contactEditor from './ContactEditor.vue';
    import language from '../api/lang';
    export default {
        components: {
            pagedLoading: pagedLoading,
            modalX: modalX,
            contactEditor: contactEditor
        },
        props: ["apiClient", "catId", "hideAddNew","userId","pickupEntry","skipAddress"],
        data: function () {
            return {
                items: [],
                paging: { page: 1, pageSize: 1, count: 1 },
                loadingImg: false,
                msg: null,
                phoneArea: "Phone Area",
                city: "Select a City",
                newContact: {
                    phoneAreaNo: null,
                    cityNo: null,
                    title: null,
                    name: null,
                    phone: null,
                    address: null,
                    pickContactId: 0
                },
                addressTab: 0, //0 for direct address, 1 for pickup
                showEditor: false
            };
        },
        computed: {
            // apiClient: function () {
            //     return this.mxnAgxApi.contactsApiClient;
            // },
            lang: function () {
                //return this.$store.getters.lang;
                return language;
            }
        },
        methods: {
            onContactCreated: function (ret) {
                this.showEditor = false;
                this.onPageChange(1);
            },
            selectPickup: function () {
                this.apiClient.pickupSelector((ret) => {
                    console.log(ret);
                }).show();
            },
            selectPhoneArea: function () {
                this.apiClient.phoneAreaSelector((ret) => {
                    this.phoneArea = ret.parent.name + "/" + ret.child.name;
                    this.newContact.phoneAreaNo = ret.child.catId;
                }).show();
            },
            selectCity: function () {
                this.apiClient.citySelector((ret) => {
                    this.city = ret.parent.name + "/" + ret.child.name;
                    this.newContact.cityNo = ret.child.catId;
                }).show();
            },
            reload: function () {
                this.loadItems();
            },
            addContact: function () {
                this.apiClient.addContactPrms(this.newContact)
                    .done((ret) => {
                        this.loadItems();
                    });
            },
            onPageChange: function (newPage) {
                this.paging.page = newPage;
                this.loadItems();
            },
            onSelect: function (contact) {
                this.$emit('onselect', contact);
            },
            loadItems: function () {
                var that = this;
                var filterObj = { ...this.paging };
                if (typeof (this.catId) !== 'undefined') {
                    filterObj.catId = this.catId;
                }
                this.loadingImg = true;
                this.apiClient.getContactsPrms(queryString().getString(filterObj)).done(function (ret) {
                    that.loadingImg = false;
                    var filter = ret.filter;
                    that.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    that.items = ret.items;
                }).fail(function () {
                    that.loadingImg = false;
                });
            }
        }
        ,
        created: function () {
            this.loadItems();
            //this.apiClient.onLoginApi.on(this.loadItems);
        },
        //destroyed: function () {
        //    this.apiClient.onLoginApi.remove(this.loadItems);
        //}
    }
</script>